<template>
    <v-container style="padding-top:70px">
        <div v-if="showcargando == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1">
            <v-card width="100%" class="mx-2">
                <MenuOP></MenuOP>
            </v-card>
        </v-row>
        <v-row mb-2>
            <v-chip class="ma-2 chipSize" :color="color" style="align-self: center" large>
                <span class="txtRep"> Reporte: {{ RepInd }} </span>
            </v-chip>
            <v-chip :class="colorClass" class="chipSize" style="align-self: center" large>
                <span class="txtEtiq">
                    {{ etiqueta }}
                </span>
            </v-chip>
            <v-btn icon outlined fab color="#29B6F6" style="align-self: center" @click="Archivos()" class="btnSize">
                <v-icon dark>mdi-folder-open</v-icon>
            </v-btn>
            <v-tooltip bottom
                v-if="((svfhcerrado.length < 1 || svfhcerrado.length == undefined) || (permisoNotas == true))">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon outlined fab color="#29B6F6" style="align-self: center" @click="Notas()"
                        class="btnSize ml-2" v-on="on" v-bind="attrs">
                        <v-icon dark>mdi-tag-text-outline</v-icon>
                    </v-btn>
                </template>
                <span>Notas</span>
            </v-tooltip>
            <v-chip style="align-self: center" class="ml-3"
                v-if="(svfhcerrado.length < 1 || svfhcerrado.length == undefined)">
                <template v-for="(item, index) in favorito">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip v-on="on" v-bind="attrs" @click="Eliminar(item)" style="align-self: center"
                                :color="tipocolo(index)" text-color="white">
                                <v-icon>
                                    {{ item.cficon }}
                                </v-icon>
                            </v-chip>
                        </template>
                        <span>{{ item.cfnombre }}</span>
                    </v-tooltip>
                </template>
                <v-tooltip bottom v-if="favorito.length < 3">
                    <template v-slot:activator="{ on, attrs }">
                        <v-chip style="align-self: center; color: aliceblue;" x-small color="grey darken-2" class="ml-2"
                            v-on="on" v-bind="attrs" @click="Nuevo()">
                            ...
                        </v-chip>
                    </template>
                    <span>Asignar Categoría</span>
                </v-tooltip>
            </v-chip>
            <v-btn
                v-if="movAutConclusion == 1 && svpuedeconcluir == 1 && saestatusolcon == 2 && (svfhcerrado.length < 1 || svfhcerrado.length == undefined) && concluirPer == true"
                style="align-self: center" class="ma-2 white--text movBtn" color="red" @click="ValidarConclusion()"
                :loading="loadingBtn">
                <v-icon start style="margin-right: 5px" color="white">mdi-archive</v-icon>
                Conclusión
            </v-btn>

            <template
                v-if="(permisoLider == true && (svfhcerrado.length < 1 || svfhcerrado.length == undefined) && horasTranscurridas <= 50 && lduslogin == uslogin) || (svpuedeconcluir == 0 && saestatusolcon == 1 && (svfhcerrado.length < 1 || svfhcerrado.length == undefined) && movSoliConclusion == 1 && AutoriConclu == true)">
                <v-btn @click="pushTo('AutorizarConclusion')" style="align-self: center" class="ma-2 white--text movBtn"
                    color="#ef6c00">
                    <v-icon start style="margin-right: 5px" color="white">mdi-checkbox-marked-outline</v-icon>
                    Autorizar Conclusión
                </v-btn>
            </template>
            <v-alert v-if="archivado == true" dense border="left" type="warning" style="align-self:center;margin:15px;">
                <strong>Reporte Archivado</strong>
            </v-alert>

            <template v-if="desconclusion == 0">
                <v-btn
                    v-if="archivado == false && desconclusionPer == true && (svfhconclusion.length > 0 || svfhcerrado.length > 0)"
                    style="align-self: center" class="ma-2 movBtn" @click="pushTo('SolicitarDesconclusion')"
                    color="orange-darken-2">
                    <v-icon start style="margin-right: 5px">mdi-folder-open</v-icon>
                    Solicitar Desconclusión
                </v-btn>

            </template>

            <template v-else>
                <template
                    v-if="(lduslogin == uslogin && horasTranscurridas < 96 && permisoLider == true) || (autorizaDesconclu == true && svpuedeconcluir == 0)">
                    <v-btn v-if="archivado == false" @click="pushTo('AutorizarDesconclusion')"
                        class="ma-2 white--text movBtn" style="align-self: center" color="#ef6c00">
                        <v-icon start style="margin-right: 5px" color="white">mdi-checkbox-marked-outline</v-icon>
                        Autorizar Desconclusión
                    </v-btn>

                </template>

                <template v-else>
                    <v-btn class="ma-2 white--text movBtn btnProc" style="
                        align-self: center;
                        cursor: not-allowed;
                        pointer-events: none;
                      ">
                        <v-icon start style="margin-right: 5px" color="gray"></v-icon>
                        En Proceso de desconclusión
                    </v-btn>
                </template>
            </template>

            <!--Vehiculo-->
            <v-col class="text-right" v-if="reporte != null">

                <template v-if="showCalificacion && (validaConclusion || permisoTerminoCalidad)">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <div v-on="on" v-bind="attrs" style="display: inline-block;">
                                <v-btn rounded style="pointer-events: none;">
                                    <span class="calificacion">{{ calificacion }}</span>
                                    <v-icon class="btnCar" :color="colorCali">
                                        mdi-star
                                    </v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <span>{{ EncuestaTermino }}</span>
                    </v-tooltip>
                </template>
                <template v-if="reporte.aiclave == 1">
                    <template v-if="RepLeg == 1">
                        <v-tooltip v-if="svvehlib == 0 && savehlib == 1 && savehlibestatus == 0" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculo" icon fab v-on="on" v-bind="attrs">
                                    <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                        mdi-car
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Vehículo Detenido ({{ this.diasVeh }}) Días</span>
                        </v-tooltip>
                        <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 0"
                            offset-x="25" offset-y="15" overlap bottom color="#5a57a7" icon="mdi-exclamation">
                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="btnVehiculo" icon fab v-on="on" v-bind="attrs">
                                        <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                            mdi-car
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Corralón / Vehículo Detenido ({{ this.diasVeh }}) Días</span>
                            </v-tooltip>
                        </v-badge>
                        <v-tooltip v-if="svvehlib == 0 && corralon == 0 && savehlibestatus == 1" bottom>

                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculoPurple" icon fab v-on="on" v-bind="attrs">
                                    <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                        mdi-car
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Vehículo Detenido ({{ this.diasVeh }}) Días</span>
                        </v-tooltip>
                        <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 1"
                            offset-x="25" offset-y="15" overlap bottom color="orange" icon="mdi-exclamation">
                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="btnVehiculoPurple" icon fab v-on="on" v-bind="attrs">
                                        <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                            mdi-car
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Corralón / Vehículo Detenido ({{ this.diasVeh }}) Días</span>
                            </v-tooltip>
                        </v-badge>
                    </template>

                    <template v-else>
                        <v-tooltip v-if="svvehlib == 0 && savehlib == 1 && savehlibestatus == 0" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculo" icon fab v-on="on" v-bind="attrs">
                                    <v-icon class="btnCar" color="grey-lighten-1"> mdi-car </v-icon>
                                </v-btn>
                            </template>
                            <span>Vehículo Detenido ({{ this.diasVeh }}) Días</span>
                        </v-tooltip>

                        <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 0"
                            offset-x="25" offset-y="15" overlap bottom color="#5a57a7" icon="mdi-exclamation">
                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="btnVehiculo" icon fab v-on="on" v-bind="attrs">
                                        <v-icon class="btnCar" color="grey-lighten-1">
                                            mdi-car
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>Corralón / Vehículo Detenido ({{ this.diasVeh }}) Días</span>
                            </v-tooltip>
                        </v-badge>
                    </template>

                    <!--Volante Juridico-->

                    <template v-if="svresponsable == '  ' && esEspecial == 0">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculo" icon fab color="orange" v-on="on" v-bind="attrs">
                                    <v-icon color="white"> mdi-format-float-left </v-icon>
                                </v-btn>
                            </template>
                            <span>Volante jurídico no capturado</span>
                        </v-tooltip>
                    </template>
                </template>

                <template v-if="reporte.aiclave == 23">
                    <template v-if="RepLeg == 1">
                        <v-tooltip v-if="svvehlib == 0 && savehlib == 1 && savehlibestatus == 0" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculo" icon fab color="purple" v-on="on" v-bind="attrs">
                                    <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                        mdi-car
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Veh&iacute;culo Detenido ({{ this.diasVeh }}) D&iacute;as</span>
                        </v-tooltip>

                        <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 0"
                            offset-x="25" offset-y="15" overlap bottom color="#5a57a7" icon="mdi-exclamation">
                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="btnVehiculo" icon fab color="purple" v-on="on" v-bind="attrs">
                                        <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                            mdi-car
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>
                                    Corral&oacute;n / Veh&iacute;culo Detenido ({{ this.diasVeh }})
                                    D&iacute;as
                                </span>
                            </v-tooltip>
                        </v-badge>

                        <v-tooltip v-if="svvehlib == 0 && corralon == 0 && savehlibestatus == 1" bottom>

                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculoPurple" icon fab color="purple" v-on="on" v-bind="attrs">
                                    <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                        mdi-car
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Veh&iacute;culo Detenido ({{ this.diasVeh }}) D&iacute;as</span>
                        </v-tooltip>

                        <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 1"
                            offset-x="25" offset-y="15" overlap bottom color="orange" icon="mdi-exclamation">
                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="btnVehiculoPurple" icon fab color="purple" v-on="on" v-bind="attrs">
                                        <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                            mdi-car
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>
                                    Corral&oacute;n / Veh&iacute;culo Detenido ({{ this.diasVeh }})
                                    D&iacute;as
                                </span>
                            </v-tooltip>
                        </v-badge>
                    </template>

                    <template v-else>
                        <v-tooltip v-if="svvehlib == 0 && (corralon == 1 || savehlib == 1) && savehlibestatus == 0"
                            bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculo" icon fab color="purple" v-on="on" v-bind="attrs">
                                    <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                        mdi-car
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Veh&iacute;culo Detenido ({{ this.diasVeh }}) D&iacute;as</span>
                        </v-tooltip>
                    </template>
                </template>

                <template v-if="reporte.aiclave == 24">
                    <template v-if="RepLeg == 1">
                        <v-tooltip v-if="svvehlib == 0 && savehlib == 1 && savehlibestatus == 0" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculo" icon fab color="purple" v-on="on" v-bind="attrs">
                                    <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                        mdi-car
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Veh&iacute;culo Detenido ({{ this.diasVeh }}) D&iacute;as</span>
                        </v-tooltip>
                        <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 0"
                            offset-x="25" offset-y="15" overlap bottom color="#5a57a7" icon="mdi-exclamation">
                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="btnVehiculo" icon fab color="purple" v-on="on" v-bind="attrs">
                                        <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                            mdi-car
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>
                                    Corral&oacute;n / Veh&iacute;culo Detenido ({{ this.diasVeh }})
                                    D&iacute;as
                                </span>
                            </v-tooltip>
                        </v-badge>
                        <v-tooltip v-if="svvehlib == 0 && corralon == 0 && savehlibestatus == 1" bottom>

                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculoPurple" icon fab color="purple" v-on="on" v-bind="attrs">
                                    <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                        mdi-car
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Veh&iacute;culo Detenido ({{ this.diasVeh }}) D&iacute;as</span>
                        </v-tooltip>
                        <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 1"
                            offset-x="25" offset-y="15" overlap bottom color="orange" icon="mdi-exclamation">
                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="btnVehiculoPurple" icon fab color="purple" v-on="on" v-bind="attrs">
                                        <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                            mdi-car
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>
                                    Corral&oacute;n / Veh&iacute;culo Detenido ({{ this.diasVeh }})
                                    D&iacute;as
                                </span>
                            </v-tooltip>
                        </v-badge>
                    </template>

                    <template v-else>
                        <v-tooltip v-if="svvehlib == 0 && savehlib == 1 && savehlibestatus == 0" bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btnVehiculo" icon fab color="purple" v-on="on" v-bind="attrs">
                                    <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                        mdi-car
                                    </v-icon>
                                </v-btn>
                            </template>
                            <span>Veh&iacute;culo Detenido ({{ this.diasVeh }}) D&iacute;as</span>
                        </v-tooltip>

                        <v-badge class="badgeClass" v-if="svvehlib == 0 && corralon == 1 && savehlibestatus == 0"
                            offset-x="25" offset-y="15" overlap bottom color="#5a57a7" icon="mdi-exclamation">
                            <v-tooltip bottom>

                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="btnVehiculo" icon fab color="purple" v-on="on" v-bind="attrs">
                                        <v-icon class="btnCar" style="pointer-events: none" color="grey-lighten-1">
                                            mdi-car
                                        </v-icon>
                                    </v-btn>
                                </template>
                                <span>
                                    Corral&oacute;n / Veh&iacute;culo Detenido ({{ this.diasVeh }})
                                    D&iacute;as
                                </span>
                            </v-tooltip>
                        </v-badge>
                    </template>
                </template>
                <!--Relevante-->

                <template v-if="relevante == 1">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon fab color="white" v-on="on" v-bind="attrs">
                                <v-icon class="btnBook" :color="sarelevante">
                                    mdi-bookmark
                                </v-icon>
                            </v-btn>
                        </template>
                        <span>{{ this.redescripcion }}</span>
                    </v-tooltip>
                </template>
            </v-col>
        </v-row>
        <v-dialog transition="dialog-bottom-transition" persistent v-model="dialog" max-width="600">
            <template>
                <v-card style="height: 340px !important;">
                    <v-toolbar color="primary" dark>Categorías</v-toolbar>
                    <v-card-text>
                        <v-row class="mt-1">
                            <v-col cols="12" md="12">
                                <v-form ref="form" v-model="valid" lazy-validation>
                                    <label class="typo__label" style="text-align: center;">Categoría:</label>
                                    <multiselect v-model="categoria"
                                        deselect-label="No se puede remover el valor seleccionado" label="cficon"
                                        track-by="cfnombre" selected-label="Seleccionado"
                                        select-label="Seleccionar valor" placeholder="Seleccionar opción"
                                        :options="categorias" :allow-empty="false" :max-height="150">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <span class="option__title">
                                                    <v-icon color="success">{{ props.option.cficon }}</v-icon>
                                                    {{ props.option.cfnombre }}
                                                </span>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <span class="option__title">
                                                    <v-icon color="success">{{ props.option.cficon }}</v-icon>
                                                    {{ props.option.cfnombre }}
                                                </span>
                                            </div>
                                        </template>
                                    </multiselect>
                                    <span style="color: #ff4081;" v-show="validaicon">Selección requerida</span>
                                </v-form>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-btn color="success" @click="add()">
                                    <v-icon>mdi-plus-box-outline</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="mt-2">
                            <v-col cols="12" class="text-center">
                                <v-btn class="ma-2" color="primary" @click="Guardar()">
                                    Guardar
                                    <template v-slot:loader>
                                        <span>Loading...</span>
                                    </template>
                                </v-btn>
                                <v-btn class="ma-2" color="default" @click="Cerrar()">
                                    Cerrar
                                </v-btn>

                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </template>
        </v-dialog>
        <v-dialog transition="dialog-bottom-transition" persistent v-model="addDialog" max-width="600">
            <template>
                <addCategoria @Cerrar="CerrarDialog()" :Arraycategorias="categorias" :Datosreporte="reporte"
                    @nuevo="NuevoEmit()" @eventoCargarFav="CargarFavoritosEmit"></addCategoria>
            </template>
        </v-dialog>

        <Menu v-if="reporte != null" @Pagina="pushTo"></Menu>
        <router-view @ReloadEncabezado="RecargarHeader"></router-view>
    </v-container>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
//import Store from "@/store/index.js";
import Asistencia from '@/services/AsistenciaGeneral/AsistenciaGeneral.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Menu from '@/components/pages/AsistenciaGeneral/Menu.vue';
import MenuOP from "@/components/pages/operacion/MenuEstadisticas/Menu.vue";
import ExpJur from '@/components/pages/ExpJur/Reporte.vue';
import Reporte from "@/services/ExpJur/ExpJur.service.js";
import ConclusionServ from "@/services/Conclusion/Conclusion.service.js";
import General from "@/services/ReporteGeneral/ReporteGeneral.service.js";
import ReporteRCM from '@/services/RCMedico/RCMedico.service.js';
import addCategoria from '@/components/pages/operacion/MisPendientes/favorito/addCategoria.vue';
//const domain = Store.state.domain;

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        MenuOP,
        Menu,
        ExpJur,
        addCategoria
    },
    provide() {
        return {
            datosReporte: this.reporte,
        };
    },
    data() {
        return {
            showcargando: true,
            reporte: null,
            encabezado: {},
            mobileMenuShowedName: '',
            colorClass: "",
            //movAutConclusion: 0,
            //svpuedeconcluir: 0,
            //saestatusolcon: 0,
            //concluirPer: false,
            svresponsable: "",
            RepInd: "",
            svfhconclusion: "",
            svfhcerrado: "",
            color: "",
            etiqueta: "",
            tipo: "",


            RepLeg: 0,
            savehlib: 0,
            svvehlib: 0,
            savehlibestatus: 0,
            diasVeh: 0,
            corralon: 0,
            purpleCarBtn: false,
            relevante: 0,
            sarelevante: '',
            redescripcion: "",
            desconclusion: 0,
            desconclusionPer: false,
            Lduslogin: "",
            svpuedeconcluir: 0,
            saestatusolcon: 0,
            permisoLider: false,
            autorizaDesconclu: false,
            concluirPer: false,
            movAutConclusion: 0,
            AutoriConclu: false,
            HorasCond: 0,
            horasTranscurridas: 0,
            uslogin: "",
            colorClass: "",
            menu: '',
            loadingBtn: false,
            displayInputs: {},
            archivado: false,
            movSoliConclusion: 0,
            asistenciaurl: '',
            nameu: '',
            user: '',
            favorito: {},

            dialog: false,
            valid: true,
            categorias: [],
            categoria: null,
            validaicon: false,
            addDialog: false,
            esEspecial: 0,
            //
            showCalificacion: false,
            calificacion: 0,
            colorCali: null,
            EncuestaTermino: '',
            validaConclusion: false,
            permisoTerminoCalidad: false,
            ///
            permisoNotas: false
        }
    },
    watch: {
        /* "$store.state.reporteMenuOption"(val) {
            console.log('watch', val)
            if (val == 'NoView') {
                this.setMobileMenuSelectedOption("NoView");
            }
            else
                this.setMobileMenuSelectedOption(val);
            //this.getInitialData();
        }, */
        etiqueta(val) {
            if (val == "Abierto") {
                this.colorClass = "marginChip";
            } else if (val == "Concluido") {
                this.colorClass = "marginChipRed";
            } else if (val == "Cancelado") {
                this.colorClass = "marginChipPurple";
            } else if (val == "Conclusión Administrativa") {
                this.colorClass = "marginChipYellow";
            }
        },
    },
    computed: {
        ...mapState(['permission', 'domain']),
        ...mapGetters(['getUser', 'THEME_STATE']),
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        Notas() {
            this.$router.push({ path: this.asistenciaurl + '/Notas' });
        },
        RecargarHeader() {
            this.getInitialData();
        },
        async ValidarConclusion() {
            this.loadingBtn = true;
            let val = await ConclusionServ.ValidarConclusion(this.reporte);
            if (val.mensaje != "") {
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Información",
                    html: `${val.mensaje}`,
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: '#536DFE',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowHtmlTags: true,
                }).then(() => {
                    if (val.tipo == 1) {
                        this.$router.push({ path: this.asistenciaurl + '/ConcluirConclusion', params: { auxtipo: 1 } });
                    }
                });
            } else {
                this.$router.push({ path: this.asistenciaurl + '/ConcluirConclusion', params: { auxtipo: 0 } });
            }
            this.loadingBtn = false;
        },
        Archivos() {
            this.$router.push({ path: this.asistenciaurl + "/Archivos" });
        },
        async Permisos() {
            if (this.reporte.aiclave == 1) {
                //Asis Jur
                await MetodosGenerales.verificarPermisoSolo(
                    this.domain.domainNameForApi,
                    "VerificarPermiso",
                    "91, 49,92,135,29,393,395"
                ).then((response) => {
                    if (response.data.length > 0) {
                        response.data.forEach((object) => {
                            if (object.peclave == 91) this.desconclusionPer = true;
                            else if (object.peclave == 49) this.permisoLider = true;
                            else if (object.peclave == 92) this.autorizaDesconclu = true;
                            else if (object.peclave == 135) this.concluirPer = true;
                            else if (object.peclave == 29) this.AutoriConclu = true;
                            else if (object.peclave == 393) this.permisoNotas = true;
                            else if (object.peclave == 395) this.permisoTerminoCalidad = true;


                        });
                    }
                });
            }
            else if (this.reporte.aiclave == 5) {
                await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '165, 49,166,158,30,393,395').then(response => {
                    if (response.data.length > 0) {
                        response.data.forEach(object => {
                            if (object.peclave == 165)
                                this.desconclusionPer = true;
                            else if (object.peclave == 49)
                                this.permisoLider = true;
                            else if (object.peclave == 166)
                                this.autorizaDesconclu = true;
                            else if (object.peclave == 158)
                                this.concluirPer = true;
                            else if (object.peclave == 30)
                                this.AutoriConclu = true;
                            else if (object.peclave == 393) this.permisoNotas = true;
                            else if (object.peclave == 395) this.permisoTerminoCalidad = true;

                        });
                    }
                });
            }
            else if (this.reporte.aiclave == 23) {
                //RLV
                await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '161, 49,162,134,50,393,395').then(response => {
                    if (response.data.length > 0) {
                        response.data.forEach(object => {
                            if (object.peclave == 161)
                                this.desconclusionPer = true;
                            else if (object.peclave == 49)
                                this.permisoLider = true;
                            else if (object.peclave == 162)
                                this.autorizaDesconclu = true;
                            else if (object.peclave == 134)
                                this.concluirPer = true;
                            else if (object.peclave == 50)
                                this.AutoriConclu = true;
                            else if (object.peclave == 393) this.permisoNotas = true;
                            else if (object.peclave == 395) this.permisoTerminoCalidad = true;

                        });
                    }
                });
            }
            else if (this.reporte.aiclave == 24) {
                await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '163, 49,164,156,155,393,395').then(response => {
                    if (response.data.length > 0) {
                        response.data.forEach(object => {
                            if (object.peclave == 163)
                                this.desconclusionPer = true;
                            else if (object.peclave == 49)
                                this.permisoLider = true;
                            else if (object.peclave == 164)
                                this.autorizaDesconclu = true;
                            else if (object.peclave == 156)
                                this.concluirPer = true;
                            else if (object.peclave == 155)
                                this.AutoriConclu = true;
                            else if (object.peclave == 393) this.permisoNotas = true;
                            else if (object.peclave == 395) this.permisoTerminoCalidad = true;

                        });
                    }
                });
            } else if (this.reporte.aiclave == 27) {
                await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '369, 370,371,372,393,395').then(response => {
                    if (response.data.length > 0) {
                        response.data.forEach(object => {
                            if (object.peclave == 372)
                                this.desconclusionPer = true;
                            else if (object.peclave == 371)
                                this.autorizaDesconclu = true;
                            else if (object.peclave == 370)
                                this.concluirPer = true;
                            else if (object.peclave == 369)
                                this.AutoriConclu = true;
                            else if (object.peclave == 393) this.permisoNotas = true;
                            else if (object.peclave == 395) this.permisoTerminoCalidad = true;

                        });
                    }
                });
            }
        },
        async getInitialData() {
            let encabezado = await Reporte.EncabezadoReporte(this);
            this.RepInd = encabezado.nrreportei;
            this.color = encabezado.color;
            this.etiqueta = encabezado.etiqueta;
            this.tipo = parseInt(encabezado.tipo);

            //Botones
            this.RepLeg = parseInt(encabezado.RepLeg);
            this.savehlib = parseInt(encabezado.savehlib);
            this.svvehlib = parseInt(encabezado.svvehlib);
            this.savehlibestatus = parseInt(encabezado.savehlibestatus);
            this.diasVeh = parseInt(encabezado.DiasVeh);
            this.corralon = parseInt(encabezado.corralon);
            this.relevante = parseInt(encabezado.relevante);
            this.sarelevante = encabezado.sarelevante;
            this.redescripcion = encabezado.redescripcion;
            this.svresponsable = encabezado.svresponsable;
            this.lduslogin = encabezado.lduslogin;
            this.horasTranscurridas = parseInt(encabezado.horasTranscurridas);
            this.svpuedeconcluir = parseInt(encabezado.svpuedeconcluir);
            this.saestatusolcon = parseInt(encabezado.saestatusolcon);
            this.uslogin = this.getUser.get(this.permission.global).uslogin;
            this.svfhconclusion = encabezado.fhconclusion;
            this.svfhcerrado = encabezado.fhcerrado;
            this.esEspecial = encabezado.esEspecial;

            var data = await Reporte.VerificarDesconclusion(this.reporte);
            this.desconclusion = parseInt(data);
            this.movAutConclusion = this.reporte.aiclave == 5 ? await ReporteRCM.MovAutConclusuion(this.reporte) : await Reporte.MovAutConclusuion(this.reporte);
            this.movSoliConclusion = this.reporte.aiclave == 5 ? await ReporteRCM.MovSolicitud(this.reporte) : await Reporte.MovSolicitud(this.reporte);
            this.Permisos();
        },
        async pushTo(param) {
            let value = "DetalleExpJur";
            if (param != null && param != undefined) {
                value = param;
            }
            let url = await this.setMobileMenuSelectedOption(param);
            this.$router.push({ path: url });
            //this.changeReporteMenuOption(param);
        },
        setMobileMenuSelectedOption(value) {
            let url = '', asistencia = '';
            asistencia = this.asistenciaurl;
            switch (value) {
                case "Detalle General":
                    this.mobileMenuShowedName = "Detalle General";
                    url = asistencia + '/ReporteDetalle';
                    break;
                case "Honorario":
                    this.mobileMenuShowedName = "Honorarios";
                    url = asistencia + '/Honorario';
                    break;
                case "Liberación Vehículo":
                    this.mobileMenuShowedName = "Liberación Vehículo";
                    url = asistencia + '/LiberacionVeh';
                    break;
                case "Volante Jur.":
                    this.mobileMenuShowedName = "Volante Jur.";
                    url = asistencia + '/Volante';
                    break;
                case "Judicialización":
                    this.mobileMenuShowedName = "Judicializaci\u00F3n";
                    url = asistencia + '/Judicializacion';
                    break;
                case "Garantías":
                    this.mobileMenuShowedName = "Garantías";
                    url = asistencia + '/Garantias';
                    break;
                case "Desconclusión":
                    this.mobileMenuShowedName = "Desconclusión";
                    url = asistencia + '/Desconclusion';
                    break;
                case "Contraloría":
                    this.mobileMenuShowedName = "Contraloría";
                    url = asistencia + '/Contraloria';
                    break;
                case "R.C. Profecional":
                    this.mobileMenuShowedName = "R.C. Profesional";
                    url = asistencia + '/ProfesionalRCMedico';
                    break;
                case "NoView":
                    this.mobileMenuShowedName = "Menú";
                    break;
                case "Movimiento":
                    url = asistencia + '/MovimientoGeneral';
                    this.mobileMenuShowedName = value;
                    break;
                case "Cobros":
                    url = asistencia + '/Cobros';
                    this.mobileMenuShowedName = value;
                    break;
                case "AutorizarConclusion":
                    this.mobileMenuShowedName = "AutorizarConclusion";
                    url = asistencia + '/AutorizarConclusion';
                    break;
                case "SolicitarDesconclusion":
                    this.mobileMenuShowedName = "SolicitarDesconclusion";
                    url = asistencia + '/SolicitarDesconclusion';
                    break;
                case "AutorizarDesconclusion":
                    this.mobileMenuShowedName = "AutorizarDesconclusion";
                    url = asistencia + '/AutorizarDesconclusion';
                    break;
                case "Impulsos Procesales":
                    this.mobileMenuShowedName = "ImpulsosProcesales";
                    url = asistencia + '/ImpulsosProcesales';
                    break;

            }
            return url;
        },
        /*Favoritos */
        async Eliminar(item) {
            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea eliminar la categoría del reporte?",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
                allowEscapeKey: false,
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal.showLoading();
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.reporte.nrreporte);
                    formdata.append("svindice", this.reporte.svindice);
                    formdata.append("frid", item.frid);
                    General.EliminarFavorito(formdata).then(data => {
                        if (data.success) {
                            this.CargaFavorito();
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito!",
                                text: "Se eliminó la categoría asignado al reporte",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error!",
                                html: "No se puede Eliminar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            }).then((result) => {

                            });
                        }
                    });
                }
            });
        },
        tipocolo(item) {
            switch (item) {
                case 0:
                    return 'blue';
                    break;
                case 1:
                    return 'teal';
                    break;
                case 2:
                    return 'cyan';
                    break;
            }
        },
        async Nuevo() {
            this.categoria = null;
            this.validaicon = false;
            this.frid = 0;
            let formdata = new FormData();
            formdata.append("uslogin", this.user);
            let data = await General.ObtenerCategorias(formdata);
            await this.CargaFavorito();
            if (data.length > 0) {
                this.categorias = data;
                for (let a in this.favorito) {
                    this.categorias = this.categorias.filter(item => item.cfid != this.favorito[a].cfid);
                }
            }
            this.addDialog = false;
            this.dialog = true;
        },
        async add() {
            this.dialog = false;
            let formdata = new FormData();
            formdata.append("uslogin", this.user);
            let data = await General.ObtenerCategorias(formdata);
            if (data.length > 0) {
                this.categorias = data;
                this.total = this.categorias.length;
                for (let a in this.favorito) {
                    this.categorias = this.categorias.filter(item => item.cfid != this.favorito[a].cfid);
                }
            }
            this.addDialog = true;
            this.validaicon = false;
        },
        async Guardar() {
            if (this.categoria != null) {
                if (this.sending) { // Verifica si ya se está enviando
                    return; // Si es así, no hace nada
                }
                this.sending = true;
                await this.CargaFavorito();
                this.$swal.showLoading();
                let formdata = new FormData();
                formdata.append("nrreporte", this.reporte.nrreporte);
                formdata.append("svindice", this.reporte.svindice);
                formdata.append("uslogin", this.user);
                formdata.append("frid", this.frid);
                formdata.append("cfid", this.categoria.cfid);
                let contador = await General.ContadorFavorito(formdata);

                if (contador.success && contador.result[0].contador == 3) {
                    this.$swal({
                        position: "center",
                        icon: "info",
                        title: "Advertencia!",
                        html: "El reporte alcanzó el máximo de 3 categorías que se puede asignar",
                        confirmButtonText: "Aceptar",
                        showConfirmButton: true,
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        timer: 5000,
                    }).then((result) => {

                    });
                } else {
                    await General.GuardarFavorito(formdata).then(data => {
                        this.favorito.cficon = this.categoria.cficon;
                        this.favorito.cfnombre = this.categoria.cfnombre;
                        if (data.success) {
                            this.CargaFavorito();

                            this.dialog = false;
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Éxito!",
                                text: "La categoría se guardo correctamente",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            });
                        }
                        else {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Error!",
                                html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                confirmButtonText: "Aceptar",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                timer: 4000,
                            }).then((result) => {

                            });
                        }
                    });
                }

                this.sending = false;
            }
            else {
                this.validaicon = true;
            }
        },
        Cerrar() {
            this.categoria = null;
            this.dialog = false;
        },
        CerrarDialog() {
            this.dialog = true;
            this.addDialog = false;
        },
        async NuevoEmit() {
            this.categoria = null;
            this.validaicon = false;
            this.frid = 0;
            let formdata = new FormData();
            formdata.append("uslogin", this.user);
            let data = await General.ObtenerCategorias(formdata);
            await this.CargaFavorito();
            if (data.length > 0) {
                this.categorias = data;
                for (let a in this.favorito) {
                    this.categorias = this.categorias.filter(item => item.cfid != this.favorito[a].cfid);
                }
            }
            this.addDialog = false;
        },
        async CargarFavoritosEmit() {
            let form = new FormData();
            form.append("nrreporte", this.reporte.nrreporte);
            form.append("svindice", this.reporte.svindice);
            form.append("uslogin", this.user);
            let fav = await General.ObtenerFavorito(form);
            this.favorito = fav.result;
            this.Cerrar();
        },
        async CargaFavorito() {
            let form = new FormData();
            form.append("nrreporte", this.reporte.nrreporte);
            form.append("svindice", this.reporte.svindice);
            form.append("uslogin", this.user);
            let fav = await General.ObtenerFavorito(form);
            this.favorito = fav.result;
        },
        async ObtenerCalificacion() {
            let response = await General.ObtenerCalificacion(this, this.reporte.nrreporte, this.reporte.svindice);
            this.showCalificacion = response.Mostrar;
            this.calificacion = response.calificacion;
            this.colorCali = response.colorCali;
            this.EncuestaTermino = response.encuestaTermino;
        }
    },
    async mounted() {
        let url = '';

        this.nameu = MetodosGenerales.ObtenerUserName();
        this.reporte = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.user = MetodosGenerales.ObtenerUserName();

        await this.getInitialData();
        let form = new FormData();
        form.append("nrreporte", this.reporte.nrreporte);
        form.append("svindice", this.reporte.svindice);

        this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.reporte);
        //this.$store.state.reporteMenuOption = 'NoView'

        if (this.$store.state.reporteMenuOption != '') {
            this.changeReporteMenuOption(this.$store.state.reporteMenuOption);
            this.setMobileMenuSelectedOption(this.$store.state.reporteMenuOption);
        }

        if (this.$route.name != 'DetalleExpJur' && this.$route.name != 'DetalleRobo' && this.$route.name != 'DetalleRLV' && this.$route.name != 'Asistencias') {
            //this.$router.push({ path: this.$route.path });
        }
        else {

            if (this.$route.path != this.asistenciaurl + '/ReporteDetalle') {
                url = this.$router.resolve({ path: this.asistenciaurl + '/ReporteDetalle' });
                history.replaceState({
                    page: "Detalle",
                }, 'Detalle', url.href);
                this.$router.push({ path: this.asistenciaurl + '/ReporteDetalle' });
            }
        }

        let respuesta = await MetodosGenerales.getReporteEstatus(this);
        this.validaConclusion = respuesta != 1 ? false : true;


        var deshabilitado = await General.VerificarReporte(this.displayInputs);

        this.CargaFavorito();

        if (deshabilitado == 1) {
            this.archivado = true;
        }
        await this.ObtenerCalificacion();

        this.showcargando = false;
    },
}
</script>
